/**
 * OS enum used by the Attribution Options surface. Lives in
 * constants/ (not in actions/) so the reducer can read these
 * without triggering the actions → store → reducers circular import
 * chain that breaks Jest's module-evaluation order.
 *
 * Backed by the same numeric values the APIv2 stores in the
 * `attribution_options.os` column.
 */
export const OS_IOS = 1;
export const OS_ANDROID = 2;
export const OS_WEB_APP = 4;
